import GradePage from "@/pages/GradePage";
export default function GradeGrade3() {
  return <GradePage grade="3" />;
}
